import { EFinancingProgram } from '@if/core/types'
import { Add, Calculate } from '@mui/icons-material'
import { Menu, MenuItem, Stack } from '@mui/material'
import { useFeatureFlags } from '@src/data/selectors/app-config-selectors'
import { getProgramsByCompanyId } from '@src/data/types/FinancingCompanies'
import { MouseEvent, useMemo, useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import IconButtonWithTooltip from '../../components/IconButtonWithTooltip'
import { usePreferences } from '@src/providers/PreferencesProvider'
import { useOptionalUser } from '@src/providers/UserProvider'

const MainActions = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const featureFlags = useFeatureFlags()
  const { selectedCompany } = usePreferences()
  const user = useOptionalUser()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const availableFinancingProgramMenuItems = useMemo(
    () => {
      let programs = getProgramsByCompanyId([selectedCompany!]);
      if (!featureFlags.useIFXFinancingProgram) {
        programs = programs.filter(x => x !== EFinancingProgram.IfXpress)
      }
      return programs.map((item) => (
      <MenuItem key={item} onClick={() => navigate(`/Applications/${item}/add`)}>
        {t(`EFinancingProgram.${item}`, { ns: 'enum' })}
      </MenuItem>
    ))
    },
    [navigate, selectedCompany, t, featureFlags],
  )

  return (
    <Stack direction="row">
      <IconButtonWithTooltip
        tooltip={t('browseCreditApplications.mainActions.newApplication')}
        icon={<Add color="primary" />}
        onClick={handleClick}
        disabled={!user?.rights.canEditCreditApp}
      />
      <IconButtonWithTooltip
        tooltip={t('browseCreditApplications.mainActions.calculate')}
        icon={<Calculate color="primary" />}
        onClick={() => undefined}
      />
      <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
        {availableFinancingProgramMenuItems}
      </Menu>
    </Stack>
  )
}

export default MainActions
